import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover, gray3, gray4, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	triggerButton: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 4,
		padding: '2px 6px',
		background: 'transparent',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		fontSize: 11,
		color: gray4,
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.05)',
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	iconContainer: {
		position: 'relative' as const,
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	calendarIcon: {
		width: 14,
		height: 14,
		color: brandPrimary,
	},
	badge: {
		position: 'absolute' as const,
		bottom: -3,
		right: -5,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 10,
		height: 10,
		borderRadius: '50%',
		backgroundColor: brandPrimary,
		color: white,
	},
	badgeIcon: {
		width: 6,
		height: 6,
	},
	dateText: {
		color: gray3,
		fontSize: 12,
		paddingLeft: 5,
	},
	popoverContent: {
		padding: 4,
		minWidth: 220,
	},
	popoverLabel: {
		fontSize: 12,
		fontWeight: 600,
		marginBottom: 8,
		color: gray3,
	},
	clearButton: {
		marginTop: 8,
		padding: '4px 8px',
		background: 'transparent',
		border: 'none',
		color: brandPrimaryHover,
		cursor: 'pointer',
		fontSize: 11,
		textDecoration: 'underline',
		':hover': {
			color: brandPrimary,
		},
	},
});
